import { forwardRef, PropsWithoutRef } from 'react';

import { Box, BoxProps } from './Box';

export type TextProps = BoxProps;

export const Text = forwardRef<any, PropsWithoutRef<TextProps>>((props, ref) => (
  <Box ref={ref} {...props} __themeKey="text" />
));
